export const CV_WAREHOUSE_KEYS = {
  INTRO_NL: "Job intro NL",
  INTRO_FR: "Job intro FR",
  LEVEL: "Niveau",
  ADVANTAGES: "Job voordelen",
  CATEGORY: "Job voor...",
  BUSINESS_LINE: "Business line",
  HIGHLIGHTED: "Highlighted",
  HQ_NL: "Hoofdkwartier",
  HQ_FR: "Headquarters",
  OFFICE_NL: "Kantoor",
  OFFICE_FR: "Office",
  YES: "Yes",
  KEYWORDS: "Keywords Jobsite",
  COORDINATES: "Coördinaten",
};
